import React,{useState, useEffect, useRef} from 'react';
import JsxParser from 'react-jsx-parser'
import { Row, Col, Form, Input, Button, Tag, Card, Select} from 'antd';

import {AutoCompleteProdutos, Estoque, Dinheiro} from '../../componentes';
import { List } from 'antd';
import { faBarcodeRead } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAxios } from '../../hooks';

import * as JsBarcode from 'jsbarcode';




    

    
    
const useEtiquetas = () => {
    
    const {getApiEmitirNotas} = useAxios();

    const buscarModelos = async () => {
        const api = await getApiEmitirNotas();
        const result = await api.get('/etiquetas/');
        return result.data;
    }

    return {buscarModelos};
}


const FormAddEtiquetas = ({onAddImpressao}) => {
    const [produtoSelecionado, setProdutoSelecionado] = useState(false);
    const [modelos, setModelos] = useState([]);
    const [opcoesModelos, setOpcoesModelos] = useState([]);
    
    const [form]= Form.useForm();
    const {buscarModelos} = useEtiquetas();

   

    const adicionarEtiqueta = (values) => {
        
        const etiqueta = {
            codigo: produtoSelecionado.codigo,
            quantidade: parseInt((values.quantidade +"").replace(" Etiquetas")),
            preco: produtoSelecionado.vUnCom,
            descricao: produtoSelecionado.descricao
        }
        console.log("onAddImpressao", onAddImpressao)
        onAddImpressao && onAddImpressao(etiqueta);
        setProdutoSelecionado(false);
        form.resetFields();
    }

    const defineProduto = (produto) => {
        console.log(produto);
        
        setProdutoSelecionado(produto);
        
        setTimeout(()=>{
            let saldo = produto.saldoEstoque;
            if(saldo < 0){
                saldo = 1;
            }
            form.setFieldsValue({
                quantidade: saldo
            })

        }, 20)
        
    }
    return  (<>
                <Form layout="inline" form={form} onFinish={adicionarEtiqueta}>
                <Form.Item label="Produto" name="produto">
                        <AutoCompleteProdutos onSelectProduto={defineProduto}></AutoCompleteProdutos>
                </Form.Item>
            
                                          
                    
                        
                        {(()=>{
                            if(produtoSelecionado){
                            return ([ 
                                       (  <Form.Item 
                                                label="Quantidade" 
                                                name="quantidade" 
                                                key={produtoSelecionado.uuid}
                                                
                                                onChange={evt=>{}}
                                                
                                            >   
                                                <Estoque 
                                                    displayType="input" 
                                                    customInput={Input} 
                                                    style={{textAlign: 'right'}} 
                                                    type="text"       
                                                    unMedida=" Etiquetas"   
                                                    isNumericString={false}
                                                    allowNegative={false}
                                                    fixedDecimalScale={true}
                                                    decimalScale={0}
                                                    />
                                            </Form.Item>),
                                            (<Form.Item key="sbmt_button">
                                                <Button type="default"  htmlType="submit">Adicionar para Impressão</Button>
                                            </Form.Item>)
                                    ]
                                    );
                            }                        
                        })()}
                </Form>
            </>)

}



const Etiquetas = ()=>{
    const [etiquetas, setEtiquetas] = useState([]);
    const [etiquetasRenderizadas, setEtiquetasRenderizadas] = useState([]);
    const [modelos, setModelos] = useState([]);
    const [opcoesModelos, setOpcoesModelos] = useState([]);
    const [formularioEtiqueta] = Form.useForm()
    const {buscarModelos} = useEtiquetas();

    const [estiloPrintArea, setEstiloPrintArea] = useState({})
    const [estiloEtiqueta, setEstiloEtiqueta] = useState({})
    const [estiloDescricao, setEstiloDescricao] = useState({});
    const [estiloPreco, setEstiloPreco] = useState({});
    const printArea = useRef();


    const onAddImpressao = () => (etiqueta) => {

        const etqs = Array.from( etiquetas);
        etqs.push(etiqueta);
        setEtiquetas(etqs);

    }
    useEffect(() => {
        executaBuscarModelos();
    }, []);

    const executaBuscarModelos = async () => {
        const modelos = await buscarModelos();
        const opcoesModelos = modelos.map(modelo => (<Select.Option value={modelo.id}>{modelo.nome}</Select.Option>))
        setModelos(modelos);
        setOpcoesModelos(opcoesModelos);
    }

    const imprimir = (etiquetaImpressao) => {

        
        let modeloSelecionado = modelos.filter(modelo => modelo.id == etiquetaImpressao.modelo);
        modeloSelecionado = modeloSelecionado[0] || false;

        const calculaQuantidadeColunas = function(){
            return parseInt((modeloSelecionado.larguraPapel - (modeloSelecionado.margemEsquerda + modeloSelecionado.margemDireita)) / modeloSelecionado.larguraEtiqueta);
        }

        const calculaEtiquetasEmBranco = () => {
            const linha = parseInt(etiquetaImpressao.linhaInicial);
            const coluna = parseInt(etiquetaImpressao.colunaInicial);
            const etiquetasPorLinha = calculaQuantidadeColunas();
            const qtdEtiquetasBranco = (( linha - 1 ) * etiquetasPorLinha ) + (coluna - 1);
            return qtdEtiquetasBranco;
        }

        const isEan = (s)=>{

            if(s && s.length == 13){

                let result = 0;
                let i = 1;
                for (let counter = s.length-1; counter >=0; counter--){
                    result = result + parseInt(s.charAt(counter)) * (1+(2*(i % 2)));
                    i++;
                }
                return (10 - (result % 10)) % 10;
            } else {
                return false;
            }
        }

        var qtdEtiquetasBranco = calculaEtiquetasEmBranco();
        const modelo = modeloSelecionado;
        
      
        etiquetaImpressao.etiquetas = [];
        
        if(qtdEtiquetasBranco){
            etiquetaImpressao.etiquetas.push({
                codigo: '',
                descricao: '',
                preco: '',
                quantidade: qtdEtiquetasBranco
            });
        }
          
        
        etiquetas.forEach(function(etiqueta){
            etiquetaImpressao.etiquetas.push(etiqueta);
            

        })

        renderizaEtiquetas( etiquetaImpressao.etiquetas, modeloSelecionado.template);


        setTimeout(function(){
            const produtos = new Set(etiquetas);

            console.log(produtos);
            produtos.forEach(produto => {

                let format = "CODE128";
                let flat = true;
                if(isEan(produto.codigo)){
                    format = "ean13"
                  //  flat = false;
                }
                console.log(format)

                JsBarcode(".codigoBarras.codigo_" + produto.codigo, produto.codigo,{
                    height: modeloSelecionado.alturaCodigoBarras,
                    fontSize: modeloSelecionado.tamanhoFonteCodigoBarras,
                    margin: modeloSelecionado.margemCodigoBarras,
                    marginRight: modeloSelecionado.margemRightCodigoBarras,
                    marginLeft: modeloSelecionado.margemLeftCodigoBarras,
                    marginTop: modeloSelecionado.margemTopCodigoBarras,
                    marginBottom: modeloSelecionado.margemBottomCodigoBarras,
                    flat,
                    textMargin: modeloSelecionado.margemTextoCodigoBarras,
                    width: modeloSelecionado.larguraCodigoBarras,
                    format
                });
            });

            //[atencao, adicionar o print-area sem mostrar para o usuario, criar uma forma dinamica por produto adicionado, com classe especifica para o barcode]
            

             var popupWinindow = window.open('', '_blank', 'titlebar=no,width=1000,height=600,scrollbars=no,menubar=no,toolbar=no,location=no,status=no');
             popupWinindow.document.open();
             var innerContents =printArea.current.outerHTML;// document.getElementById('print-area').outerHTML;
            
             popupWinindow.document.write(
                    `<html >
                        <head>
                            <meta name="viewport" content="width=100%, initial-scale=1">
                            <style>
                           
                          
                                @media print {
                                    * {
                                        background:transparent !important;
                                        color:#000 !important;
                                        text-shadow:none !important;
                                        filter:none !important;
                                        -ms-filter:none !important;
                                        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif, sans-serif;
                                    }

                                    @page { 
                                        size:  ${modelo.larguraPapel}mm ${modelo.alturaPapel}mm; 
                                        margin-top: ${modelo.margemSuperior}mm; 
                                        margin-left: ${modelo.margemEsquerda}mm;
                                        margin-right: ${modelo.margemDireita}mm;
                                        margin-bottom: ${modelo.margemInferior}mm;
                                        
                                    }
                                    
                                    body, html { 
                                        background: white; 
                                        width: ${modelo.larguraPapel}mm;
                                        
                                        margin: 0;
                                    }   
                                    
                                    
                                    body {
                                        line-height: 1.4em;
                                        display: block;
                                    }
    
                                    .etiqueta{
                                        width: ${modelo.larguraEtiqueta}mm;
                                        margin-right: ${modelo.espacamentoHorizontal}mm;
                                        float: left;
                                        height: ${modelo.alturaEtiqueta}mm;
                                        margin-bottom: ${modelo.espacamentoVertical}mm;
    
                                    } 
                                    
                                    .preco{
                                        font-size: ${modelo.tamanhoPreco}mm;
                                        line-height: ${modelo.tamanhoPreco}mm;
                                        margin-top: ${modelo.espacamentoPreco}mm;
                                    }
    
                                    .descricao{
                                        font-size: ${modelo.tamanhoDescricao}mm;
                                        line-height: ${modelo.tamanhoDescricao}mm;
                                    }
    
                                    .print-area{
                                        margin-top: 0mm;
                                        padding: 0;
                                        margin-left: 0px !important;
                                        width: 100%;
                                    }
                                }

                                
                            </style>
                        </head>
                        <body onload="window.print()">
                            ${innerContents} 
                        </html>`);

             popupWinindow.document.close();

             formularioEtiqueta.resetFields();          

        }, 500);




    }

    const renderizaEtiquetas = (etiquetas, modelo = null) => {
        let print = [];
        etiquetas.forEach((etiqueta)=> {
            for(let i = 0; i< etiqueta.quantidade; i++){
                if(modelo){
                    
                    print.push(
                        <JsxParser jsx={modelo} onError={(err)=> console.log("err =>", err)}  components={{Dinheiro}} bindings={{estiloEtiqueta, estiloDescricao,estiloPreco, etiqueta}} ></JsxParser>
                    );

                } else{

                    if(etiqueta.codigo){
                        
                        print.push((
                            <div className="etiqueta quebra-pagina" style={estiloEtiqueta} >
                                <svg className={"codigoBarras codigo_" + etiqueta.codigo} ></svg>
                                <div className="descricao" style={estiloDescricao}>{etiqueta.descricao}</div>
                                <div className="preco" style={estiloPreco}>
                                    <Dinheiro value={etiqueta.preco}></Dinheiro></div>
                            </div>            
                        ))
                    } else {
                        print.push((
                            <div className="etiqueta quebra-pagina" style={estiloEtiqueta} >
                                <div className="descricao" style={estiloDescricao}></div>
                                <div className="preco" style={estiloPreco}></div>
                            </div>            
                        ));
                    }
                }

            }
        })
        setEtiquetasRenderizadas(print);
    };

    const removerEtiqueta = (etiqueta) => () => {
        const novaLista = Array.from(etiquetas);

        const indice = etiquetas.indexOf(etiqueta);
        novaLista.splice(indice, 1);
        
        setEtiquetas(novaLista);
    }

    const removerTodasEtiqueta = () => {
        const novaLista =[];
        setEtiquetas(novaLista);
    }

    return (<>
        <Row style={{padding: "23px"}}>
            <Col span={24} style={{textAlign: 'left'}}>
                <h1>Etiquetas</h1>
            </Col>
           
            <Col span={24}>
                <FormAddEtiquetas onAddImpressao={onAddImpressao()}></FormAddEtiquetas>
            </Col>

            <Col span={24} style={{marginTop: '23px'}}>
                <Card >


                    <List
                        size="small"
                        itemLayout="horizontal"
                        dataSource={etiquetas}
                        renderItem={etiqueta => (
                            <List.Item key={etiqueta.codigo}>
                                <List.Item.Meta
                                avatar={<FontAwesomeIcon size="2x" icon={faBarcodeRead} />}
                                title={<div style={{textAlign: "left"}}><Tag>{etiqueta.quantidade} Etiquetas</Tag> {etiqueta.codigo} - {etiqueta.descricao}</div>}
                                
                                />
                                <div>
                                    <Button type="link" color="danger" onClick={removerEtiqueta(etiqueta)}>Remover</Button>
                                </div>
                            </List.Item>
                        )}
                    />
                </Card>
            </Col>
            <Col span={24} style={{marginTop: '23px'}}>
                
                <Form layout="inline" form={formularioEtiqueta} onFinish={imprimir}>
                    <Row gutter={12} style={{textAlign:'left'}}  align="bottom" >
                        <Col span={6}>
                            <Form.Item name="modelo" >
                                {/* <label style={{textAlign:'left'}}>Modelo</label> */}
                                <Select>
                                    {opcoesModelos}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item  name="colunaInicial" label="Coluna">
                                
                                <Input></Input>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item name="linhaInicial" label="Linha">
                                
                                <Input></Input>
                            </Form.Item>
                        </Col>
                        <Col >
                            <Form.Item >
                                
                                <Button htmlType="submit">Imprimir</Button>
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item >
                                
                                <Button type="link" onClick={removerTodasEtiqueta}>Começar denovo</Button>
                            </Form.Item>
                        </Col>
                    </Row>

                </Form>
            </Col>
        </Row>
        
        

        <div style={{ height: 0, overflow: 'hidden', display: 'block'}}>

            <div id='print-area' className="print-area" ref={printArea}>
                <div class="page">

                    {etiquetasRenderizadas}

                </div>
            </div>
        </div>
        
    </>);
}

export {Etiquetas};